"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FetchMore = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const react_1 = require("react");
const constants_1 = require("../../../../constants");
const elements_1 = require("../../../../elements");
const hooks_1 = require("../../../../hooks");
const FetchRow = styled_1.default.tr(({ canFetchMore }) => ({
    background: constants_1.Color.LIGHTER_BLUE,
    display: canFetchMore ? 'table-row' : 'none',
}));
const FetchMore = (props) => {
    const [fetchMoreRef, isInView] = (0, hooks_1.useInView)();
    (0, react_1.useEffect)(() => {
        if (isInView && props.canFetchMore)
            props.fetchMore();
    }, [isInView]);
    return ((0, jsx_runtime_1.jsx)(FetchRow, { ref: fetchMoreRef, canFetchMore: props.canFetchMore, children: (0, jsx_runtime_1.jsx)("td", { colSpan: 8, children: (0, jsx_runtime_1.jsx)(elements_1.Flex, { items: "center", styles: {
                    height: constants_1.theme.spacing['4'],
                    justifyContent: 'center',
                    width: '100%',
                }, children: (0, jsx_runtime_1.jsx)(elements_1.Loader, { color: constants_1.Color.BLUE, size: "small" }) }) }) }));
};
exports.FetchMore = FetchMore;
